/* Good on You · shared behaviour
   Header, Drawer, Reveal, Cart-Toast, Scroller, Sorten-Tabs, Gallery, Sticky ATC, Filter */
(() => {
  const html = document.documentElement;
  html.classList.add('js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Load choreography
  if (!document.getElementById('loader')) requestAnimationFrame(() => requestAnimationFrame(() => html.classList.add('loaded')));

  // Header hide/show + scrolled state
  const header = document.querySelector('.site-header');
  let lastY = scrollY, ticking = false;
  const onScroll = () => {
    const y = scrollY;
    if (!header) return;
    header.classList.toggle('is-scrolled', y > 8);
    if (y > 160 && y > lastY + 6) header.classList.add('is-hidden');
    else if (y < lastY - 6) header.classList.remove('is-hidden');
    lastY = y; ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });

  // Header-Suche
  const hs = document.querySelector('.hsearch');
  document.querySelectorAll('[data-open-search]').forEach(a => a.addEventListener('click', (e) => { if (!hs) return; e.preventDefault(); hs.hidden = !hs.hidden; if (!hs.hidden) hs.querySelector('input').focus(); }));
  document.querySelectorAll('[data-close-search]').forEach(b => b.addEventListener('click', () => { hs.hidden = true; }));

  // Drawer
  const drawer = document.getElementById('goy-drawer');
  document.querySelectorAll('[data-open-drawer]').forEach(b => b.addEventListener('click', () => drawer.showModal()));
  document.querySelectorAll('[data-close-drawer]').forEach(b => b.addEventListener('click', () => drawer.close()));
  drawer?.addEventListener('click', e => { if (e.target === drawer) drawer.close(); });

  // Reveal on scroll (content stays visible without JS / in headless)
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  // Safety: anything still hidden after 2.5s becomes visible
  setTimeout(() => document.querySelectorAll('.reveal:not(.in)').forEach(el => el.classList.add('in')), 2500);

  // GOY Warenkorb-Drawer: Add/Change über /cart/*.js, Section-Rendering ersetzt Drawer + Icon
  const toast = document.getElementById('toast'); let tt;
  const say = (msg) => { if (!toast) return; toast.querySelector('span').textContent = msg; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('is-on'), 2600); };
  const SECTIONS = 'goy-cart-drawer,cart-icon-bubble';
  const swapSections = (sections) => {
    if (!sections) return;
    if (sections['goy-cart-drawer']) { const wrap = document.getElementById('shopify-section-goy-cart-drawer'); if (wrap) { const open = wrap.querySelector('.gc')?.classList.contains('is-open'); wrap.outerHTML = sections['goy-cart-drawer']; if (open) document.getElementById('goy-cart')?.classList.add('is-open'); bindCart(); } }
    if (sections['cart-icon-bubble']) { const el = document.getElementById('cart-icon-bubble'); if (el) { const tmp = document.createElement('div'); tmp.innerHTML = sections['cart-icon-bubble']; el.innerHTML = tmp.querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble']; } }
  };
  const openCart = () => { const gc = document.getElementById('goy-cart'); if (!gc) { location.href = '/cart'; return; } gc.classList.add('is-open'); gc.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('gc-lock'); };
  const closeCart = () => { const gc = document.getElementById('goy-cart'); if (!gc) return; gc.classList.remove('is-open'); gc.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('gc-lock'); };
  const cartPost = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: location.pathname }) });
    const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); swapSections(j.sections); return j;
  };
  const addToCart = async (btn) => {
    const id = btn.dataset.variantId, qty = +btn.dataset.qty || 1; if (!id) { say('Kein Produkt verknüpft'); return; }
    btn.classList.add('is-busy');
    try { await cartPost('/cart/add.js', { id: +id, quantity: qty }); openCart(); } catch (e) { say(e.message); } finally { btn.classList.remove('is-busy'); }
  };
  const bindCart = () => {
    const gc = document.getElementById('goy-cart'); if (!gc) return;
    gc.querySelectorAll('[data-gc-close]').forEach(b => b.onclick = closeCart);
    gc.querySelectorAll('[data-atc]').forEach(b => b.onclick = (e) => { e.preventDefault(); addToCart(b); });
  };
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('.gc-item [data-qty]'); if (!q) return;
    const line = q.closest('.gc-item').dataset.line; q.closest('.gc-item').classList.add('is-busy');
    try { await cartPost('/cart/change.js', { line: +line, quantity: +q.dataset.qty }); if (document.querySelector('.gcp')) location.reload(); } catch (err) { say(err.message); }
  });
  document.addEventListener('click', (e) => { if (e.target.closest('#cart-icon-bubble')) { e.preventDefault(); openCart(); } });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
  document.querySelectorAll('[data-atc]:not(#goy-cart [data-atc])').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); addToCart(b); }));
  bindCart();
  window.goyCart = { add: addToCart, open: openCart, post: cartPost };

  // Produktformular (PDP): Varianten-Chips → Variante, Menge, Submit via /cart/add.js
  document.querySelectorAll('form[data-goy-product]').forEach(f => {
    const data = f.querySelector('[data-variants]'); const variants = data ? JSON.parse(data.textContent) : null;
    const idInput = f.querySelector('[data-variant-input]'); const submit = f.querySelector('[data-atc-submit]');
    const priceBox = document.getElementById('goy-price');
    const money = (c) => (c/100).toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    const sync = () => {
      if (!variants) return;
      const opts = [...f.querySelectorAll('.variant-group')].map(g => { const on = g.querySelector('input:checked'); return on ? on.value : null; });
      const v = variants.find(x => opts.every((o, i) => o === null || x.options[i] === o));
      if (!v) return; idInput.value = v.id;
      submit.disabled = !v.available; submit.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (priceBox) priceBox.querySelector('.now').textContent = money(v.price);
      document.querySelectorAll('.sticky-atc [data-atc]').forEach(b => b.dataset.variantId = v.id);
      const u = new URL(location); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    f.querySelectorAll('.variant-group input').forEach(i => i.addEventListener('change', sync));
    const qOut = f.querySelector('output'); const qIn = f.querySelector('input[name="quantity"]');
    f.querySelectorAll('.qty button').forEach(b => b.addEventListener('click', () => { const n = Math.max(1, (+qOut.value || 1) + (+b.dataset.step)); qOut.value = n; qIn.value = n; }));
    f.addEventListener('submit', async (e) => {
      e.preventDefault(); submit.classList.add('is-busy');
      try {
        await cartPost('/cart/add.js', { id: +idInput.value, quantity: +qIn.value || 1 }); openCart();
      } catch (err) { say('Konnte nicht hinzugefügt werden'); } finally { submit.classList.remove('is-busy'); }
    });
  });

  // Horizontal scroller arrows
  document.querySelectorAll('[data-scroller]').forEach(wrap => {
    const track = wrap.querySelector('.scroller');
    wrap.querySelectorAll('[data-dir]').forEach(b => b.addEventListener('click', () => {
      const w = track.firstElementChild.getBoundingClientRect().width + 18;
      track.scrollBy({ left: b.dataset.dir === 'next' ? w : -w, behavior: reduce ? 'auto' : 'smooth' });
    }));
  });

  // Sorten-Tabs (Zahnpflege)
  document.querySelectorAll('[data-flavors]').forEach(root => {
    const tabs = root.querySelectorAll('[data-flavor]');
    const imgs = root.querySelectorAll('.flavor-stage img');
    const stage = root.querySelector('.flavor-stage');
    const desc = root.querySelector('.flavor-desc');
    const atc = root.querySelector('[data-atc]');
    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(x => x.setAttribute('aria-pressed', x === t));
      imgs.forEach(i => i.classList.toggle('is-on', i.dataset.flavor === t.dataset.flavor));
      stage.style.background = t.dataset.wash;
      desc.textContent = t.dataset.desc;
      if (atc) atc.dataset.atc = `Zahnpasta ${t.textContent.trim()}`;
    }));
  });

  // PDP gallery
  const gal = document.querySelector('.gallery-main');
  if (gal) {
    const figs = [...gal.querySelectorAll('figure')];
    const thumbs = [...document.querySelectorAll('.gallery-thumbs button')];
    const dots = [...document.querySelectorAll('.gallery-dots i')];
    const setOn = i => { thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); };
    thumbs.forEach((t, i) => t.addEventListener('click', () => figs[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' })));
    const gio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) setOn(figs.indexOf(e.target)); }), { root: gal, threshold: .6 });
    figs.forEach(f => gio.observe(f));
  }

  // Quantity
  document.querySelectorAll('.qty').forEach(q => {
    if (q.closest('form[data-goy-product]')) return;
    const out = q.querySelector('output');
    q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      out.value = Math.max(1, (+out.value || 1) + (+b.dataset.step));
    }));
  });

  // Sticky ATC after buybox leaves viewport
  const buy = document.querySelector('.buybox .atc-row');
  const sticky = document.querySelector('.sticky-atc');
  if (buy && sticky) {
    document.body.classList.add('has-sticky');
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0 && scrollY > 200), { threshold: 0 }).observe(buy);
    addEventListener('scroll', () => { if (scrollY < 200) sticky.classList.remove('is-on'); }, { passive: true });
  }

  // Collection filter
  const grid = document.querySelector('[data-filter-grid]');
  if (grid) {
    const cards = [...grid.querySelectorAll('.pcard')];
    const chips = document.querySelectorAll('[data-filter]');
    const out = document.querySelector('.result-count');
    const apply = (f) => {
      let k = 0;
      cards.forEach(c => { const on = f === 'all' || (c.dataset.tags || '').split(' ').includes(f); c.hidden = !on; if (on) k++; });
      if (out) out.textContent = `${k} Produkte`;
    };
    chips.forEach(ch => ch.addEventListener('click', () => { chips.forEach(x => x.setAttribute('aria-pressed', x === ch)); apply(ch.dataset.filter); }));
    apply('all');
  }

})();

/* Gründerstory-Fächer */
document.querySelectorAll('[data-fan]').forEach(fan => {
  const sec = fan.closest('.founder'); const cards = [...fan.querySelectorAll('.fan-card')];
  const panels = [...sec.querySelectorAll('.fan-panel')]; const dots = [...sec.querySelectorAll('.fan-dots i')];
  let cur = 0;
  const go = n => {
    cur = (n + cards.length) % cards.length; fan.style.setProperty('--cur', cur);
    cards.forEach((c, i) => { c.classList.toggle('is-on', i === cur); c.classList.toggle('is-behind', i < cur); });
    panels.forEach((p, i) => p.classList.toggle('is-on', i === cur));
    dots.forEach((d, i) => d.classList.toggle('is-on', i === cur));
  };
  cards.forEach((c, i) => c.addEventListener('click', () => go(i === cur ? cur + 1 : i)));
  sec.querySelector('.fan-next').addEventListener('click', () => go(cur + 1));
  sec.querySelector('.fan-prev').addEventListener('click', () => go(cur - 1));
  go(0);
});
